import * as React from "react";
import PropTypes from "prop-types";
const SvgActionsKudoNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M9.234.582A1 1 0 0110.143 0h.505a4 4 0 013.976 4.442L14.117 9h5.42a3.462 3.462 0 012.518 5.84l-.055.058v1.774a3 3 0 01-.879 2.12l-.121.122V20a3 3 0 01-3 3H9.303a2 2 0 01-1.11-.336L5.697 21H3a2 2 0 01-2-2v-5.5a2 2 0 01.8-1.6l3.397-2.548zm1.547 1.422l-3.873 8.414a1 1 0 01-.308.382L3 13.5V19h2.697a2 2 0 011.11.336L9.303 21H18a1 1 0 001-1v-1.914l.707-.707a1 1 0 00.293-.707v-2.57l.6-.636A1.462 1.462 0 0019.539 11h-7.655l.753-6.78a2 2 0 00-1.855-2.216z"
        fill=""
      />
    </svg>
  )
);
SvgActionsKudoNormalSmall.defaultProps = {
  color: "currentColor",
  size: 24,
  title: undefined,
  titleId: undefined,
};
SvgActionsKudoNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActionsKudoNormalSmall;
